import {chain, eq, find, get} from "lodash";
import {IStore} from "modules/types/store";
import {createSelector} from "reselect";
import {ProjectName, PromoName} from "modules/enums";
import {PROJECT_NAME} from "modules";

export const getJsonState = (state: IStore) => state.jsons;

export const getCountriesJson = createSelector(getJsonState, ({countries}) => countries);

export const getCountriesAsArray = createSelector(getCountriesJson, (countries) =>
	countries ? Object.entries<string>(countries) : []
);
export const getCountryByKey = createSelector(
	getCountriesAsArray,
	(countries) => (key: string) => find(countries, ([value, _name]) => eq(value, key))
);

export const getChecksums = createSelector(getJsonState, (jsons) => jsons.checksums);

export const getSettings = createSelector(getJsonState, ({settings}) => settings);

const PROJECT_NAME_MAP: Partial<Record<ProjectName, PromoName>> = {
	[ProjectName.Brackets]: PromoName.Brackets,
	[ProjectName.Fantasy]: PromoName.Fantasy,
	[ProjectName.FantasyDaily]: PromoName.FantasyDaily,
	[ProjectName.Trivia]: PromoName.Trivia,
	[ProjectName.GameZone]: PromoName.GameZone,
	[ProjectName.Fives]: PromoName.Fives,
	[ProjectName.HyundaiQuiz]: PromoName.HyundaiQuiz,
	[ProjectName.MatchPredictor]: PromoName.MatchPredictor,
	[ProjectName.BracketsPredictor]: PromoName.BracketsPredictor,
	[ProjectName.Budweiserpotm]: PromoName.Budweiserpotm,
	[ProjectName.WhoAmI]: PromoName.WhoAmI,
};

export const getPromoBanner = createSelector(getSettings, (settings) => {
	const promoName = get(PROJECT_NAME_MAP, PROJECT_NAME as ProjectName);

	if (!promoName) {
		return null;
	}

	return chain(settings).get("banners").get(promoName).get("game").value() as PromoName;
});
